import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = ["About", "Services", "Approach", "Contact"];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-page/95 backdrop-blur-sm shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex flex-col items-start leading-none">
          <span className="font-serif text-2xl tracking-[0.35em] text-[#1a1a1a]">TINDE</span>
          <span className="text-[9px] tracking-[0.3em] text-[#7a7a7a] mt-1">PATIENT EXPERIENCE CONSULTING</span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l}
              href={`#${l.toLowerCase().replace(" ", "-")}`}
              className="nav-link text-[11px] tracking-[0.25em] text-[#3a3a3a] uppercase"
            >
              {l}
            </a>
          ))}
        </nav>

        {/* Mobile toggle */}
        <button
          aria-label="Toggle menu"
          className="lg:hidden text-[#1a1a1a]"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-page border-t border-[#eee] px-6 py-6">
          <nav className="flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l}
                href={`#${l.toLowerCase().replace(" ", "-")}`}
                onClick={() => setMobileOpen(false)}
                className="text-[12px] tracking-[0.25em] text-[#3a3a3a] uppercase"
              >
                {l}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
